var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parking-content-card"},[_c('div',{staticClass:"header"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }